import { render, staticRenderFns } from "./ColumnRoute.vue?vue&type=template&id=70497985&scoped=true"
import script from "./ColumnRoute.vue?vue&type=script&lang=js"
export * from "./ColumnRoute.vue?vue&type=script&lang=js"
import style0 from "./ColumnRoute.vue?vue&type=style&index=0&id=70497985&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70497985",
  null
  
)

export default component.exports